module.exports = __webpack_public_path__ + "static/media/Chen.eff99d03.png";